import React, { Component } from 'react'
import styles from './style.module.less'
import HotModal from './HotModal'
import { observer } from 'mobx-react'
import { setCookie, getCookie } from '@hlj/hlj-utils'
import { getSessionMerchantInfo } from '@merchant-backend/util'

@observer
export default class extends Component {
  /**
   * 关闭顶部提醒框
   */
  closeUnfinishCard = () => {
    const merchantId = getSessionMerchantInfo().user_id || ''
    setCookie(`scheduleToolTipClosed${merchantId}`, 1, 365)
    this.forceUpdate()
  }

  render() {
    const { toggleHotModalVisible, hotModalVisible } = this.props.store

    const merchantId = getSessionMerchantInfo().user_id || ''
    const scheduleToolTipClosed = getCookie(
      `scheduleToolTipClosed${merchantId}`
    ) // 是否已经手动关闭

    return (
      !scheduleToolTipClosed && (
        <div className={styles.wrapper}>
          <div className={styles.left}>
            <i className={styles.icon} />
            <span>
              坚持使用婚礼纪档期工具，结合您的使用习惯和档期记录情况，将会为您在用户端显示「人气四大」标签，入选人气频道，尊享更多曝光机会。{' '}
              <a onClick={toggleHotModalVisible(true)}>查看详情</a>
            </span>
          </div>
          <i className={styles.close} onClick={this.closeUnfinishCard} />
          <HotModal
            visible={hotModalVisible}
            onCancel={toggleHotModalVisible(false)}
          />
        </div>
      )
    )
  }
}
